import LocalizedStrings from "react-localization";
import { AGD_DOMAIN } from "../config";

const lstrings = new LocalizedStrings({
	es: {
		actividad: "Actividad",
		actividades_title: "Actividades",
		actor: "Actor",
		agno: "Año",
		alta: "Alta",
		antecedentesmorosidad_title:
			"Antecedentes de morosidad (en créditos personales en nuestra base)",
		apellidosNombreRazon: "Apellidos, Nombre / Razón",
		aporte: "Aporte",
		aportes_ref_0: "Pago en término",
		aportes_ref_1: "Pago fuera de término",
		aportes_ref_2: "No se registra información",
		aportesAutonomoMonotributo_title: "Aportes Autónomo / Monotributo",
		aportesServDomestico_title: "Aportes empleado del servicio doméstico",
		archivo: "Archivo",
		artVigente: "ART Vigente",
		asociado: "Asociado",
		atrasos_vigentes_cc: "Atrasos Vigentes (Centro Comercial)",
		automotores_historial_title: "Historial de automotores",
		automotores_title: "Automotores actuales",
		autonomo_title: "Autónomo o Monotributista",
		baja: "Baja",
		balances_title: "Balances",
		bancos: "Bancos",
		bancosopera_title: "Bancos con los que opera",
		bienes_title: "Bienes",
		bienespersonales_title: "Bienes personales",
		bienvenida: "Hola {0}",
		bloque: "Bloque",
		boletin: "Boletín",
		boletinoficial_title: "Boletín Oficial",
		buscar: "Buscar",
		busquedarazonsocial_title: "Búsqueda por razón social",
		cantconsultaslotes: "Cantidad de consultas de Lotes",
		cantconsultasweb: "Cantidad de consultas Web",
		cantempaportes_title:
			"Cantidad de empleados que registran aportes (por año)",
		capitasDeclaradas: "Capitas Declaradas",
		caratula: "Carátula",
		cargo: "Cargo",
		categoria: "Categoría",
		causal: "Causal",
		cerrar: "Cerrar",
		chequesrechazados_title: "Cheques rechazados",
		coberturaart_title: "Cobertura ART Riesgos del Trabajo",
		codigo: "Código",
		codigoPostal: "Código Postal",
		comercioexterior_title: "Comercio Exterior",
		comparacionventasanual_title: "Comparación Ventas - Anual",
		compras: "Compras",
		condeconpymbesbcra: "Condición económica para PyMES según BCRA",
		condicion: "Condición",
		consultasexcedentes: "Consultas excedentes",
		consultasrestantes: "Consultas restantes",
		consumotarjeta_title: "Consumo tarjeta de crédito (en miles de pesos)",
		contactacion_title: "Contactación",
		contacto_mail: `consultas@${AGD_DOMAIN}`,
		contacto_tel: "011 5236 5371",
		contribucionautonomo: "Contribución autónomo",
		contribucionsegsocial: "Contribución seg. social autónomos",
		cp: "Código Postal",
		cuil: "CUIL",
		cuit: "CUIT",
		cuitcuil_title: "CUIT / CUIL",
		datosempresa_title: "Datos de la Empresa",
		datoslaborales_title: "Datos Laborales",
		datosparticulares_title: "Datos Particulares",
		demandado: "Demandado",
		descargar: "Descargar",
		descargarPdf: "Descargar a PDF",
		descripcion_title: "Descripción",
		desde: "Desde",
		detalleConsultas_title: "Detalle de consultas previas",
		detalleConsultas_cant: "Cantidad de consultas:",
		detalleConsultas_ultima: "Fecha de última consulta:",
		deudoresbcra_title: "Deudores Banco Central de la República Argentina",
		denuncias_nodoFederal: "Denuncias en Nodo Federal",
		disclaimer_pdf:
			"La información suministrada en el presente informe, extraída de bases públicas, privadas y propias, es confidencial y reservada." +
			"\n\nEl cliente es el único habilitado a consultar la información, estando expresamente prohibida la divulgación de la misma a terceros —total o parcialmente— observando el deber de confidencialidad y uso permitido, según Ley 25.236.",
		docCuitCuil: "DOC/CUIT/CUIL",
		domicilio: "Domicilio",
		domiciliofiscal_title: "Domicilio Fiscal",
		domicilioparticular_title: "Domicilio Particular",
		emaildirs_title: "Direcciones de correo electrónico",
		emailsTitle: "Mails",
		embargo: "Embargo",
		embargos_title: "Embargos",
		emp_aportes_title:
			"Cantidad de empleados que registran aportes (por año)",
		empleado: "Empleado",
		empleador: "Empleador",
		empresasNominaEmpleadosTitle: "Nómina de empleados - {0}",
		domesticosEmpleadosTitle: "Personal de Casas Particulares",
		domesticosEmpleadorTitle: "Empleados Domésticos",
		entidad: "Entidad",
		estado: "Estado",
		estadoDeuda: "Estado de la Deuda",
		expediente: "Expediente",
		exportaciones: "Exportaciónes",
		facturacionult_title: "Facturacion (último año)",
		fecha_cese: "Fecha Cese",
		fecha_inicio: "Fecha Inicio",
		fecha: "Fecha",
		fechaconstitucion: "Fecha Constitución",
		fechadesde: "Fecha Desde",
		fechahasta: "Fecha Hasta",
		fechaLevantamiento: "Fecha Levantamiento",
		fechaPago: "Fecha de Pago",
		fechaPresentacion: "Fecha de Presentación",
		fechaPresentacionArt: "Período Declarado",
		fechaPublicacion: "Fecha Publicación",
		fechaRechazo: "Fecha Rechazo",
		fecha_deuda: "Fecha de la Deuda",
		footer_pdf: "{0} - Página {1} de {2}",
		fuente: "Fuente",
		ganancias: "Ganancias",
		general_title: "General",
		generarReportePdf: "Generar Reporte en PDF",
		hasta: "Hasta",
		historialPrevisional_solicitud_title:
			"Solicitar Información - Historial Laboral",
		historialPrevisional_solicitud: "Solicitar Historial Laboral",
		historico_morosidad_title:
			"Histórico antecedentes de morosidad (en créditos personales en nuestra base)",
		id: "ID",
		importaciones: "Importaciones",
		importetotalpendiente: "Importe total pendiente:",
		importetotalrechazado: "Importe total rechazado:",
		imprimir: "Imprimir",
		impuesto_title: "Pago de Impuestos de Autónomos y Monotributistas",
		impuestos: "Impuestos",
		inculosotros_title: "Otros vínculos",
		infobcra_title:
			"Información Suministrada por el Banco Central de la República Argentina",
		infobcra_subtitle:
			"(Se visualiza la situación actual e histórica 24 meses y montos expresados en miles)",
		informe: "Informe",
		informador: "Informador",
		ingreso: "Ingreso",
		instituto: "Instituto",
		integrasociedades: "Integra Sociedades",
		invalid_two_factor_code: "Código incorrecto.",
		iva: "IVA",
		jubilacion_title: "Jubilación",
		juiciosactor_title: "Juicios - Actor",
		juiciosdemandado_title: "Juicios - Demandado",
		juzgado: "Juzgado",
		localidad: "Localidad",
		login: "",
		loginServiceExpiredException: "El servicio de la cuenta ha expirado.",
		loginCreditsException: "Su cuenta no tiene créditos disponibles.",
		loginAccessDeniedByIpException:
			"El acceso desde su IP no está autorizado.",
		loginAccountExpiredException: "La cuenta de usuario ha expirado.",
		loginBadCredentialsException: "Verfique usuario y contraseña.",
		loginBlockedException: "Su cuenta ha sido bloqueada temporalmente",
		loginCredentialsExpiredException:
			"La contraseña expiró, se le enviará un email con instrucciones para el blanqueo.",
		loginDisabledException: "Usuario temporalmente deshabilitado.",
		loginFailed: "Ha ocurrido un error inesperado.",
		loginLockedException: "Usuario temporalmente bloqueado.",
		masaSalarialDeclarada: "Masa Salarial Declarada",
		masinfo: "Más Información",
		mes_abr: "Abr",
		mes_abril: "Abril",
		mes_ago: "Ago",
		mes_agosto: "Agosto",
		mes_dic: "Dic",
		mes_diciembre: "Diciembre",
		mes_ene: "Ene",
		mes_enero: "Enero",
		mes_feb: "Feb",
		mes_febrero: "Febrero",
		mes_jul: "Jul",
		mes_julio: "Julio",
		mes_jun: "Jun",
		mes_junio: "Junio",
		mes_mar: "Mar",
		mes_marzo: "Marzo",
		mes_may: "May",
		mes_mayo: "Mayo",
		mes_nov: "Nov",
		mes_noviembre: "Noviembre",
		mes_oct: "Oct",
		mes_octubre: "Octubre",
		mes_sep: "Sep",
		mes_septiembre: "Septiembre",
		mes: "Mes",
		modoliquidacion: "Modo Liquidación",
		monotributo: "Monotributo",
		monotributoautonomo: "Monotributo autónomo",
		monotributosegsocial: "Monotributo seg. social",
		monto: "Monto",
		morosidad_title: "Morosidad",
		multa: "Multa",
		nivelIngreso: "Nivel de Ingreso",
		no_data: "No se encontraron datos",
		no_file: "Ningún archivo seleccionado",
		nombre_cia: "AgilData Online",
		nombre: "Nombre",
		notificaciones_no_data: "No hay notificaciones",
		notificaciones: "Notificaciones",
		nrocelular: "Número de celular",
		nrotelefono: "Número de teléfono",
		numeroCheque: "Nro. Cheque",
		numeroOficio: "Nro. Oficio",
		objeto: "Objeto",
		obrasocial_title: "Obra Social",
		obrasocialaportes: "Obra social aportes",
		obrasocialcontribuciones: "Obra social contribuciones",
		obrasocialretenciones: "Obra social retenciones",
		observaciones_title: "Observaciones",
		origenDeuda: "Origen de la Deuda",
		otros: "Otros",
		otrosdomicilios_title: "Otros Domicilios",
		padron: "Padrón",
		panelVerazTitle: "Fuente Equifax Veraz",
		participacionotrassociedades: "Participación en otras sociedades",
		participacionsociedades_title: "Participación en Sociedades",
		participacionsocietaria_title: "Participación Societaria",
		mencionesboletinoficial_title: "Menciones en Boletín Oficial",
		pendientespago: "Pendientes Pago:",
		periodo: "Período",
		periodoArt: "Fecha de Inicio",
		periodoUltimo: "Último Período Informado",
		personas: "Personas",
		personasrelacempresa: "Personas relacionadas a la empresa",
		propiedades_title: "Propiedades",
		provincia: "Provincia",
		quiebras_concursos_title: "Quiebras y Concursos",
		rangoingreso: "Rango de Ingresos",
		razonsocial: "Razón Social",
		referencia: "Referencia",
		referencias_title: "Referencias",
		relaciondependencia_title: "Relación de Dependencia",
		resp: "Resp.",
		rol: "Rol",
		sector: "Sector",
		seguridadsocial_title: "Seguridad Social",
		seguridadsocialaportes: "Seguridad Social Aportes",
		seguridadsocialcontribuciones: "Seguridad Social Contribuciones",
		seguridadsocialretenciones: "Seguridad social retenciones",
		serverResponse500:
			"Estamos teniendo problemas para conectarnos con el servidor.",
		serverResponsePreconditionFailed:
			"No está permitido el acceso para el usuario. Espere unos segundos e intente ingresar nuevamente.",
		situacion_0: "Sin información en BCRA.",
		situacion_1:
			"Situación normal (pago puntual o atrasos menores a 31 días).",
		situacion_2: "Con riesgo potencial (con atrasos entre 31 y 90 días).",
		situacion_3:
			"Cumplimiento deficiente (con atrasos entre 90 y 180 días).",
		situacion_4:
			"Con alto riesgo de insolvencia (con atrasos entre 180 días y 1 año).",
		situacion_5: "Irrecuperable (con atrasos mayores a 1 año).",
		situacion_6:
			"Irrecuperable por disposición técnica (entidades liquidadas, en proceso de disolución o en quiebra, en gestión judicial).",
		situacion_title: "Situación",
		situacionFinanciera_title: "Situación Financiera",
		situacionfiscal_title: "Situación Fiscal",
		sociedadesComercialesTitle: "Sociedades Comerciales",
		socioNro: "Nro Socio",
		solicitar_informacion_ok:
			"Se ha solicitado la información correctamente",
		solicitudes_adicionales: "Solicitudes Adicionales",
		subbloque: "Sub bloque",
		sueldopactadoinicio: "Sueldo pactado al inicio",
		sueldoscobrados_title: "Sueldos cobrados",
		sueldospagados_title: "Sueldos pagados",
		sueldospagos_title: "Sueldos Pagos",
		sujetoObligado: "Sujeto Obligado Registrado ante la UIF",
		sumaFija: "Suma Fija",
		superficie_cubierta: "Superficie cubierta",
		superficie_terreno: "Superficie terreno",
		telefono: "Teléfono",
		telefonos_title: "Teléfonos",
		telefonosAdicionales: "Teléfonos adicionales",
		telefonosCelulares: "Teléfonos celulares",
		telefonosPrincipales: "Teléfonos principales",
		texto: "Texto",
		tipo: "Tipo",
		tipoDeudor: "Tipo Deudor",
		tipoabono: "Tipo de abono",
		tipolinea: "Tipo de línea",
		titleAgd: "Agil Data Online",
		titleReseller: "Nodo Federal",
		titular: "Titular",
		total_consultas: "Total Consultas",
		total_veraz: "Veraz",
		total_pagado: "Total Pagado",
		total: "Total",
		ubicacion: "Ubicación",
		usuario: "Usuario",
		valorContratoAprox: "Valor Contrato Aprox.",
		variable: "Variable",
		ventas: "Ventas",
		verazInfoTitle: "Veraz",
		verazIngresosDescription: "",
		verazIngresosTitle: "Predictor de Ingresos",
		verazObsDescription:
			"Monto adeudado de la persona en concepto de préstamos y créditos otorgados.",
		verazObsTitle: "Denuncias de Morosidad Vigentes",
		verazObsCantidadTitle: "Cantidad de denuncias",
		verazObsInformanteTitle: "Informante",
		verazScoreDescription:
			"Este indicador representa la probabilidad que tiene una persona de cumplir con sus obligaciones crediticias en los próximos 12 meses.",
		verazScoreTitle: "Score de Riesgo Crediticio",
		verInformeCheques: "Ver informe de cheques denunciados",
		vigencia: "Vigencia",
		vigenciaabono: "Vigencia del abono",
		vinculos_title: "Vínculos",
		vinculosfam_title: "Vínculos familiares",
		vinculosotros_title: "Otros vínculos",
	},
});

export default lstrings;



// WEBPACK FOOTER //
// ./src/utils/LStrings.js